export { default } from './ErrorCard';
